import { ChartEntity } from '@chart/types/chart-entity.types';
import { getChartEntityLogoDisplay } from '@chart/utils/entity/chart-entity';
import { Toggle } from '@design/components/toggle/Toggle';
import { isSvgIconName, SvgIconNames } from '@design/design-tokens/iconography/SvgIcons';
import { AssetLogo } from '@design/widget-modules/asset-logo/AssetLogo';
import React from 'react';

import styles from './ChartTypeSelectorItem.module.scss';

export interface ChartTypeSelectorItemProps {
  entity: ChartEntity;
  isChecked: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const ChartTypeSelectorItem = ({
  entity,
  isChecked,
  onClick,
  disabled = false,
}: ChartTypeSelectorItemProps) => {
  const logoDisplay = getChartEntityLogoDisplay(entity);
  const safeIconName: SvgIconNames = isSvgIconName(logoDisplay.iconName)
    ? logoDisplay.iconName
    : 'ChartLine';
  const safeSubClassIcon: SvgIconNames = isSvgIconName(logoDisplay.subClassIcon)
    ? logoDisplay.subClassIcon
    : 'ChartLine';

  return (
    <div className={styles.wrapper}>
      <span className={styles.assetWrapper}>
        <AssetLogo
          type={logoDisplay.variant}
          isNotStockEntity={logoDisplay.isNotStockEntity}
          isFiEntity={logoDisplay.isFiEntity}
          placeholderIconName={safeIconName}
          placeholderSubClassIcon={safeSubClassIcon}
          entity={{
            class: entity.class,
            tag: entity.tag,
            name_short: entity.name_short,
          }}
          size={20}
          logoUrl={entity.logo_urls.light_png}
        />
        <span className={styles.assetTicker}>{entity.formattedTicker}</span>
      </span>
      <Toggle
        data-testid={`${entity.formattedTicker}toggle`}
        isChecked={isChecked}
        onClick={onClick}
        disabled={disabled}
      />
    </div>
  );
};
